import { Injectable, inject } from "@angular/core";
import { UrlTree } from "@angular/router";
import { Observable } from "rxjs";
import { JwtHelperService } from "@auth0/angular-jwt";
import { MatDialog } from "@angular/material/dialog";
import { MFACodeComponent } from "../modules/users/mfacode/mfacode.component";
import { map } from "rxjs/operators";

@Injectable({
	providedIn: "root",
})
export class SecureGuard {
	private jwtHelper = inject(JwtHelperService);
	private dialog = inject(MatDialog);

	canActivate(): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
		const decodedToken = this.jwtHelper.decodeToken();
		if ("secure" in decodedToken) {
			return decodedToken["secure"];
		}
		const dialogRef = this.dialog.open(MFACodeComponent, {
			width: "600px",
			disableClose: true,
		});
		return dialogRef.afterClosed().pipe(
			map((result) => {
				return result;
			})
		);
	}
}
